import { render } from "./SavingsViewer.vue?vue&type=template&id=3a40fd94&ts=true"
import script from "./SavingsViewer.vue?vue&type=script&lang=ts"
export * from "./SavingsViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__